export const ImagesURLObject = {
    custom_product_hero: 'https://smileycreations-seasonal-files.s3.us-east-1.amazonaws.com/Productos.webp', 
    custom_illustration_hero: 'https://smileycreations-seasonal-files.s3.us-east-1.amazonaws.com/Ilustracion.webp',
    home_hero_main: 'https://smileycreations-seasonal-files.s3.us-east-1.amazonaws.com/Portada.webp' 
}
